import { Checkbox, Form, Input, Modal, Switch } from 'antd';
import 'moment/locale/es';
import { useAuth } from '../../../../../store/AuthContext/AuthContext';
import { authFetch } from '../../../../../common/request/authFetch';
import { useState } from 'react';
import { InfoCircleOutlined } from '@ant-design/icons';

export const NewPlaceKeywordModal = (props: {place: any, onFinish: any}) => {

	const [form] = Form.useForm();
	const { projectGroup } = useAuth();

	const onFormFinish = async (values: any) => {

		const data = {
			...values            
        };

		await authFetch(`${process.env.REACT_APP_API}/projects/${projectGroup.project}/places/${props.place?.id}/keywords`, { method: 'PUT', data: data });
		props.onFinish();
	}

	return (

		<Modal width='50%' open={true} onOk={() => form.submit()} onCancel={props.onFinish} afterClose={form.resetFields}>

			<h2>{props.place?.title}</h2>			
			<i style={{color:'Teal'}}><InfoCircleOutlined/> Potenciales palabras clave pueden ser: Categoría, localización, servicios y productos. Por ejemplo <b>"Clínica Dental"</b>, <b>"Córdoba"</b>, <b>"Ortodoncia"</b>, etc,...</i>
			<br/><br/>
			<Form layout='horizontal' form={form} onFinish={onFormFinish}>
				<Form.Item
					rules={[{ required: true, message:'Por favor, ingrese la keyword' }]}
					name='keyword'
					label='Nueva Keyword'>
					<Input/>
				</Form.Item>												
			</Form>			
		</Modal>
	)
}
